export const ProjectActionTypes = {
  SET_PROJECT_LIST: "@@project/SET_PRODUCT_LIST",
  SET_SELECTED_PROJECTS_BY_CATEGORY:
    "@@project/SET_SELECTED_PROJECTS_BY_CATEGORY",
  SET_SELECTED_PROJECT_SLUG: "@@project/SET_SELECTED_PROJECT_SLUG",
  SET_SELECTED_PROJECT: "@@project/SET_SELECTED_PROJECT",
};
